import React from 'react';
import { useNavigate } from 'react-router';
import './BookDetails.css';


const Announcements = () => {
  const navigate = useNavigate(); // we make a variable that points at the function

  const handleClick = (path) => { // and when someone clicks on the button
    navigate(path); // we navigate to the path defined
  };
  const openInNewTab = (url) => { // same as handleClick but opens the link in a new tab
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <section id="book-details" className="book-details">
      <div className="announcements_content">
        <h3 className="section_title">
          March 2026 Updates
        </h3>
        <div className="announcements_image">
          <span>
            <a href="https://amazon.com/dp/B0GRCVCJ14" target="blank"><img width="600px" src="images/site-banner_3_2026.jpg" alt="Children of Nemia" /></a>
          </span>
        </div>

        <div className="announcements_text">
          <p className="body_text">

            Lots of news this month, readers! First, the audiobook is now available on Audible (scroll down to find the Amazon link).
            I'm also now a proud member of <strong><a href="https://thearcanist.net/nemia/" target="blank">The Arcanist's</a></strong> catalog, which means more ways to buy your copy. Last but not least,
            mark your calendars for the <strong><a href="https://www.visitgreensburg.com/articles/post/local-author-fair/" target="blank">Greensburg Library Local Author Fair</a></strong> -- I'll be making an appearance, so if you're in the area
            on April 25th, come show your support & find your next read!


          </p>
        </div>

      </div>
    </section>
  )
}

export default Announcements;
